import type { CostTypeMapper } from "app/pages/sales-intelligence/modules/quota/types";

import type { LeadsColumnTypeDto } from "../types";

export const leadsCostTypeMapper: CostTypeMapper<LeadsColumnTypeDto> = (columnType) => {
    switch (columnType) {
        case "utility":
            return null;

        case "signal":
            return "signalField";

        case "tech":
            return "technologyField";

        case "techCategory":
        case "techSubCategory":
            return "technologyCategoryField";

        default:
            return "basicField";
    }
};
